/** Shared physical contract for airbase rules.
 * Coordinates are model X/Z, in world units. East-side bases reflect anchor X
 * and yaw their occupants by PI. No shrink-to-fit or footprint override.
 */
export const airbaseLayoutConfig = {
  version: 2,
  footprintTiles: [7, 6],
  footprint: 224,
  slab: 220,
  slabDimensions: [220, 188],
  deckHeight: 2,
  aircraftAnchors: [
    [-45, -47],
    [35, -47],
    [-45, 31],
    [35, 31],
  ],
  droneAnchors: [
    [-56, 80],
    [-28, 80],
    [0, 80],
    [28, 80],
    [56, 80],
  ],
  // Full Petrel rotor sweep reaches 31.01636, beyond the proposed 31.
  aircraftEnvelope: { minX: -30, maxX: 24, minZ: -31.1, maxZ: 31.1 },
  droneEnvelope: { minX: -13, maxX: 13, minZ: -12, maxZ: 12, height: 8 },
  serviceEnvelope: { minX: -108, maxX: -88, minZ: -90, maxZ: 60, height: 24 },
  // Keep each vertical departure column open. Begin +X travel only after
  // clearing the highest loaded aircraft (18.5), plus a 2-unit margin.
  departureClearance: 2,
  departureHeight: 22.5,
  droneFormationSpacing: 36,
  droneMusterDistance: 120,
  droneTerminalDistance: 96,
} as const;

/** One airfield layout; placement and settings enforce its minimum footprint. */
export function airbaseLayoutFor(_footprint: readonly [number, number]) {
  return airbaseLayoutConfig;
}
